import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { CoreRoutingModule } from './core-routing.module';
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";
import { MainLayoutComponent } from "./layout/main-layout/main-layout.component";
import { PageNotFoundComponent } from "./layout/page-not-found/page-not-found.component";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "../shared/shared.module";
import { NzDropdownDirective, NzDropdownMenuComponent, NzDropdownModule } from "ng-zorro-antd/dropdown";
import { RouterModule } from "@angular/router";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NzIconModule } from "ng-zorro-antd/icon";

@NgModule( {
    imports: [
        CommonModule,
        SharedModule,
        CoreRoutingModule,
        TranslatePipe,
        NzDropdownDirective,
        NzDropdownMenuComponent,
        RouterModule.forChild([]),
        TooltipModule,
        NzDropdownModule,
        NzIconModule,
        NgOptimizedImage,
        HeaderComponent,
        FooterComponent,
        MainLayoutComponent,
        PageNotFoundComponent
    ]
} )
export class CoreModule {
}
